import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";

interface CarrierBusinessTypeProps {
  value: BusinessTypeValue;
  onChange: (value: BusinessTypeValue) => void;
}

export function CarrierBusinessType(props: CarrierBusinessTypeProps) {
  const { value, onChange } = props;

  return (
    <Stack spacing={2}>
      <Typography variant="h6" fontWeight="bold">
        Carrier Type
      </Typography>
      <RadioGroup
        value={value}
        onChange={(e) => onChange(e.target.value as BusinessTypeValue)}
      >
        <FormControlLabel
          value="TRUCKING_COMPANY"
          control={<Radio />}
          label="Trucking Company"
        />
        <Typography variant="body1" color="text.secondary">
          We own and operate our own fleet of trucks and drivers. We primarily
          handle freight transportation using our company assets.
        </Typography>
        <FormControlLabel
          value="BROKER"
          control={<Radio />}
          label="Non-Asset Broker"
        />
        <Typography variant="body1" color="text.secondary">
          We coordinate freight transportation on behalf of shippers by
          partnering with outside carriers. We do not own or operate our own
          trucks.
        </Typography>
      </RadioGroup>
    </Stack>
  );
}
